<template>
    <div>
        <el-form ref="form" :model="palmInfo" status-icon>
            <el-form-item class="form-item-darwin" label="Bunch Bag Count">
                <form-select 
                    :input-value.sync="palmInfo.fruitTypeId"
                    :options="fruitTypeOpts"
                />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import FormSelect from "@/components/Form/FormSelect";
import FormInput from "@/components/Form/FormInput";
import FormInputFloat from "@/components/Form/FormInputFloat";
import { mapGetters } from "vuex";

export default {
    components: {
        "form-input": FormInput,
        "form-input-float": FormInputFloat,
        "form-select": FormSelect,
    },
    data() {
        return {
            palmInfo: {}
        };
    },
    ...mapGetters([
        "fruitTypeOpts",
    ]),

};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Palm/CreateEditPalmForm.vue